<article>
	<header class="page-header">
		<div class="breadcrumb-line">
			<stages-breadcrumb [links]="true" [path]="breadcrumb"></stages-breadcrumb>
			@if (self) {
				<stages-process-version [type]="self.type?.ident" [identity]="self.identity"></stages-process-version>
			}
		</div>
		@if (self) {
			<stages-element-name [self]="$any(self)"></stages-element-name>
		}
	</header>

	<ng-container stagesSlot="top"></ng-container>

	<div class="container row">
		<div class="container column col-4">
			<div class="container grouped column">
				<ng-container stagesSlot="left"></ng-container>
			</div>
		</div>
		<div class="container column col-4">
			<div class="container grouped column">
				<ng-container stagesSlot="center"></ng-container>
			</div>
		</div>
		<div class="container column col-4">
			<div class="container grouped column">
				<ng-container stagesSlot="right"></ng-container>
			</div>
		</div>
	</div>
</article>
